import { FC } from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { useFormik } from 'formik'
import { object, SchemaOf, string } from 'yup'

export type IResetPasswordForm = {
    new_pass: string,
    temp_pass: string
}

const initialValues = {
    new_pass: '',
    temp_pass: '' 
}

const validationSchema: SchemaOf<IResetPasswordForm> = object().shape({
    new_pass: string().required('Required'),
    temp_pass: string().required('Required')
})

type ResetPasswordFormProps = {
    onSubmit: Function
}

const ResetPasswordForm: FC<ResetPasswordFormProps> = ({ onSubmit: onSubmitFromProps }) => {
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values) => onSubmitFromProps(values)
    })

    return (
        <Card>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit}>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Enter OTP</Form.Label>
                                <Form.Control
                                    { ...formik.getFieldProps('temp_pass') }
                                    isInvalid={ formik.touched.temp_pass && !!formik.errors.temp_pass }
                                />
                                <Form.Control.Feedback type="invalid">
                                    { formik.errors.temp_pass }
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Enter new password</Form.Label>
                                <Form.Control
                                    { ...formik.getFieldProps('new_pass') }
                                    isInvalid={ formik.touched.new_pass && !!formik.errors.new_pass }
                                    type="password"
                                />
                                <Form.Control.Feedback type="invalid">
                                    { formik.errors.new_pass }
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Button type="submit" className="float-start">Reset password</Button>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    )
}

export { ResetPasswordForm }